import React, { useEffect, useState } from 'react';
import momentTz from 'moment-timezone';
import { momentTimeFormater, timeOnly } from '../../../utils/dateHelper';
import classes from '../Home.module.css';
import { useLoader } from '../../../hooks/use-loader.hook';
import { toDkFormatter } from '../../../utils/currencyHelper';
import { NordpoolService } from '../../../services/NordpoolService';
import EChart from '../../../components/Echarts/Echarts';

const NordPoolCard = ({ groupId }) => {
    const [startLoader, stopLoader] = useLoader();
    const [data, setData] = useState([]);

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        NordpoolService.getData(momentTz().tz('Europe/Berlin').format('YYYY-MM-DD'), startLoader, handleSuccess, handleError, stopLoader);
    };

    const handleSuccess = ({ data }) => setData(data.data.graph);

    const handleError = (error) => {
        console.error(error);
    };

    return (
        <div className={classes.TopGraph} style={{ flexGrow: 1, height: '28vw' }}>
            <EChart series={data} title="Power Cost(Euro/MWh)" xFormatter={timeOnly} yFormatter={toDkFormatter} type="bar" zoomOnMouseWheel={false} yTooltipSuffix={['€', '€']} />
        </div>
    );
};

export default NordPoolCard;
